import * as React from "react";
import * as Comlink from "comlink";

import { WorkerKey, ApiMapping } from "./mapping";

export type WorkerId = string;
export type Timeout = ReturnType<typeof setTimeout>;

export type ProxiedWorker<W extends WorkerKey> = {
  id: WorkerId;
  key: W;
  inner: Worker;
  proxy: Comlink.Remote<ApiMapping[W]>;
  releaseDelay: number;
  release?: Timeout;
  terminated: boolean;
};

export type WorkerMap<W extends WorkerKey> = {
  [K: WorkerId]: ProxiedWorker<W>;
};

export type WorkerRegistry = {
  [W in WorkerKey]: WorkerMap<W>;
};

export type WorkersContextValue = {
  registry: WorkerRegistry;
};

export const createWorkersContextValue = (): WorkersContextValue => ({
  registry: Object.fromEntries(
    Object.keys(WorkerKey).map((key) => [key, {}]),
  ) as WorkerRegistry,
});

export const WorkersContext = React.createContext<WorkersContextValue>(
  createWorkersContextValue(),
);
